module.exports = __webpack_public_path__ + "img/info_icon.efc874b9.svg";